export const strikesPaths = {
    INDEX: "/"
}